import React from 'react';

import {
  Header as TopListHeaderWrapper,
  HeaderContainer,
  ContentWrapper,
  MobileWrapper,
  IconWrapper,
  SmallTitle,
  Title,
} from './PlaylistActivity.style';
import { ReactComponent as PlaylistActivityIcon } from 'icons/icon-playlist-activity-header.svg';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import Layout from 'components/styled/Layout/Layout';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';

interface IPlaylistActivityHeaderProps {
  smallTitle?: string;
  title?: string;
}

const PlaylistActivityHeader: React.FC<IPlaylistActivityHeaderProps> = (
  props
) => {
  const { smallTitle = 'Tracker', title = 'Playlist Activity' } = props;
  return (
    <InViewObserver
      render={({ inview }: any): JSX.Element => (
        <Header inView={inview} withVerticalBackground>
          <TopBar
            inView={inview}
            entityTitle={title}
            simpleTextTopBar
            inNewDesign
            isSticky
          />
          <Layout.MaxWidth>
            <HeaderContainer>
              <TopListHeaderWrapper>
                <IconWrapper>
                  <PlaylistActivityIcon />
                </IconWrapper>
                <ContentWrapper data-pw="header-top-bar">
                  <SmallTitle>{smallTitle}</SmallTitle>
                  <MobileWrapper>
                    <Title>{title}</Title>
                  </MobileWrapper>
                </ContentWrapper>
              </TopListHeaderWrapper>
            </HeaderContainer>
          </Layout.MaxWidth>
        </Header>
      )}
    />
  );
};

export default PlaylistActivityHeader;
